export const reviewsMainTranslations = {
	uk: {
		loading: 'Завантаження...',
		noReviews: 'Відгуки про товар відсутні',
		user: 'Користувач',
		orderReceived: 'Замовлення отримано',
		ratingAria: 'Рейтинг {rating} з 5',
		brandRepresentative: 'Представник бренду',
		viewAllReviews: 'ДИВИТИСЯ УСІ ВІДГУКИ',
		months: {
			0: 'січня',
			1: 'лютого',
			2: 'березня',
			3: 'квітня',
			4: 'травня',
			5: 'червня',
			6: 'липня',
			7: 'серпня',
			8: 'вересня',
			9: 'жовтня',
			10: 'листопада',
			11: 'грудня',
		},
	},
	ru: {
		loading: 'Загрузка...',
		noReviews: 'Отзывы о товаре отсутствуют',
		user: 'Пользователь',
		orderReceived: 'Заказ получен',
		ratingAria: 'Рейтинг {rating} из 5',
		brandRepresentative: 'Представитель бренда',
		viewAllReviews: 'СМОТРЕТЬ ВСЕ ОТЗЫВЫ',
		months: {
			0: 'января',
			1: 'февраля',
			2: 'марта',
			3: 'апреля',
			4: 'мая',
			5: 'июня',
			6: 'июля',
			7: 'августа',
			8: 'сентября',
			9: 'октября',
			10: 'ноября',
			11: 'декабря',
		},
	},
}
